export default [
  {
    id: "1069276121628934144",
    parentId: "0",
    menuName: "基本信息",
    menuNameEn: null,
    menuType: 1,
    icon: "iconfont icon-caidan",
    router: "/home",
    perms: "",
    remark: "",
    isVisible: 1,
    isFrame: 0,
    sort: 0,
    state: 1,
    children: []
  },
  {
    id: "1079796257070776320",
    parentId: "0",
    menuName: "合同菜单",
    menuNameEn: null,
    menuType: 1,
    icon: "iconfont icon-zidianguanli",
    router: "/contract",
    perms: "",
    remark: null,
    isVisible: 1,
    isFrame: 0,
    sort: 1,
    state: 1,
    children: [
      {
        id: "1079796257070776323",
        parentId: "1079796257070776320",
        menuName: "合同管理",
        menuNameEn: null,
        menuType: 2,
        icon: "iconfont icon-a-Property1dingdanzhihangfenxi",
        router: "/contractManage",
        perms: "",
        remark: null,
        isVisible: 1,
        isFrame: 0,
        sort: 2,
        state: 1,
        children: []
      },
      {
        id: "1079796257070776324",
        parentId: "1079796257070776320",
        menuName: "申报开户",
        menuNameEn: null,
        menuType: 2,
        icon: "iconfont icon-a-Property1dingdanzhihangfenxi",
        router: "/openAccount",
        perms: "",
        remark: null,
        isVisible: 1,
        isFrame: 0,
        sort: 3,
        state: 1,
        children: []
      },
    ]
  },
  {
    id: "1069276121628934149",
    parentId: "0",
    menuName: "商机订阅",
    menuNameEn: null,
    menuType: 1,
    icon: "iconfont icon-yonghuzhongxin",
    router: "/businessSubscription",
    perms: "",
    remark: "",
    isVisible: 1,
    isFrame: 0,
    sort: 0,
    state: 1,
    children: []
  },
  {
    id: "1079796257070776321",
    parentId: "0",
    menuName: "工作台",
    menuNameEn: null,
    menuType: 1,
    icon: "iconfont icon-a-Property1dingdanzhihangfenxi",
    router: "/staging",
    perms: "",
    remark: null,
    isVisible: 1,
    isFrame: 0,
    sort: 1,
    state: 1,
    children: [
      {
        id: "1079796257070776326",
        parentId: "1079796257070776321",
        menuName: "待办中心",
        menuNameEn: null,
        menuType: 2,
        icon: "iconfont icon-a-Property1dingdanzhihangfenxi",
        router: "/pendingCenter",
        perms: "",
        remark: null,
        isVisible: 0,
        isFrame: 0,
        sort: 2,
        state: 1,
        children: []
      },
      {
        id: "1079796257070776327",
        parentId: "1079796257070776321",
        menuName: "消息中心",
        menuNameEn: null,
        menuType: 2,
        icon: "iconfont icon-a-Property1dingdanzhihangfenxi",
        router: "/messageCenter",
        perms: "",
        remark: null,
        isVisible: 0,
        isFrame: 0,
        sort: 3,
        state: 1,
        children: []
      },
      {
        id: "1079796257070776328",
        parentId: "1079796257070776321",
        menuName: "账号资料变更",
        menuNameEn: null,
        menuType: 2,
        icon: "iconfont icon-a-Property1dingdanzhihangfenxi",
        router: "/dataChange",
        perms: "",
        remark: null,
        isVisible: 0,
        isFrame: 0,
        sort: 3,
        state: 1,
        children: []
      },
      {
        id: "1079796257070776329",
        parentId: "1079796257070776321",
        menuName: "供应商信息查看",
        menuNameEn: null,
        menuType: 2,
        icon: "iconfont icon-a-Property1dingdanzhihangfenxi",
        router: "/info",
        perms: "",
        remark: null,
        isVisible: 0,
        isFrame: 0,
        sort: 3,
        state: 1,
        children: []
      },
    ]
  },
]